<template>
  <div>
    <v-container >
      <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDates')">
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.fromDate"
            label="From Date"
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.toDate"
            label="To Date"
            class="input-text-size"
            :isToggle = "false"
            />

        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showIssueDate')">
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.issueDate"
            label="Issue Date"
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
      </v-row>
        <v-row class="elevation-1"
        v-if="showReportConfig('showTaxYears')">
        <v-col cols="6">
               <MultiItemSelect
                class="input-text-size"
                  label="By Tax Year"
                  item-text="taxYear"
                  item-value="taxYear"
                  :item-list="taxYearsList"
                  :items="criteria.taxYears"
                  @selected-items="selectedTaxYears"
                />
        </v-col>
      </v-row>
      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
      </v-row>
    </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ReportChip from '../../../reports/ReportChip.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { queryStringCalc, delenquentReportList } from './report-util';
import { getRawJwt } from '../../../../util/jwt';
import MultiItemSelect from '../../../common/base/MultiItemSelect.vue';
import { toShortDate } from '../../../../util/shared/tmc-global';

export default {
  name: 'DelenquentTaxReport',
  components: {
    ReportChip,
    ClarionDateControl,
    MultiItemSelect,

  },
  data: () => ({
    taxYearRange: [],
    criteria: {
      taxDistricts: [],
      adjTypes: [],
      taxYears: [],
      taxType: [],
      fromDate: toShortDate(),
      toDate: toShortDate(),
      issueDate: toShortDate(),
    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allTaxDistricts: false,
      allTaxYears: false,
    },
    taxTypes: [],
    defaultCriteria: {
      fy: undefined,
    },
    // taxYearsList: [],
  }),
  created() {
    // this.loadTaxDistricts();
    this.initializeTaxYear();
    // this.loadTaxTypes();
    // this.loadAdjCodes();
  },

  computed: {
    reports() {
      return [
        ...delenquentReportList(),
      ];
    },

    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: this.getAuthToken,
        defaultCriteria: this.defaultCriteria,
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,
      });
    },
    validateCriteria() {
      let isValid = true;
      if (this.criteria.fy == null) {
        isValid = false;
      }
      return isValid;
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    showReportConfig(configField) {
      return this.reportConfig.filters[configField];
    },
    async initializeTaxYear() {
      const item = await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      const data = [];
      const taxYears = [];

      // eslint-disable-next-line array-callback-return
      item.map((val) => {
        data.push({
          taxYear: val,
        });
        taxYears.push(val);
      });
      this.taxYearsList = data;
      this.criteria.taxYears = taxYears;
      return data;
    },
  },
};

</script>
